<!-- left and top nav changes container -->
<!-- class and new element added changes -->
<div class="layout-nav-top" *ngIf="isLoggedIn() && isUserDataLoaded">
  <!-- <app-dop-navbar> -->
  <dop-menu *ngIf="isFeatureFlagLoaded && !hideHeader" class="app-header" [userDetails]="userDetails"
    [featureFlags]="featureFlags" [configurations]="configurations" [eolWebsiteUrl]="eolWebsiteUrl"></dop-menu>
  <!-- new element -->
  <!-- <app-global-header class="global-header"></app-global-header> -->
  <app-page-header class="page-header" *ngIf="!hideHeader" title="{{layout.pageHeader.pageTitle}}"
    icon="{{layout.pageHeader.pageIcon}}" iconLink="{{layout.pageHeader.iconLink}}">
  </app-page-header>
  <!-- </app-dop-navbar> -->
  <p-breadcrumb *ngIf="layout.breadcrumbItems.length != 0" [model]="layout.breadcrumbItems"></p-breadcrumb>
  <div class="content">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    <router-outlet name="guidedOrderRoute" (activate)="onActivate($event)"></router-outlet>
  </div>
  <app-footer *ngIf="!hideHeader" class="app-footer"></app-footer>
</div>
<!-- end -->

<app-loading [hidden]="!loading"></app-loading>


<p-dialog [(visible)]="openAccessDeniedDialog" [modal]="true" (onHide)="closeErrorDialog()">
  <p-header>
    <i class="ei ei-warning orange"></i> &nbsp; {{'oleiAccessNotGranted' | translate}}
  </p-header>
  <div class="m-b-12">
    {{'vbeiNoSufficientPermission' | translate}}
    <br>
    {{'oleiContactAdmin' | translate}}
  </div>
  <p-footer>
    <div class="text-right">
      <button pButton class="p-button" type="button" label="{{'vbeiOk' | translate}}" (click)="closeErrorDialog()">
      </button>
    </div>
  </p-footer>
</p-dialog>


<p-dialog [(visible)]="error.displayError" [modal]="true"  [responsive]="true"  class="error-box" [minY]="70"
  [baseZIndex]="11000">
  <p-header>
    {{error.errorDialogHeader}}
  </p-header>
  <div class="m-b-12">
    <b style="white-space: pre-wrap;">
      {{error.errorMessage}}
    </b>
  </div>
  <p-footer>
    <div class="text-right">
      <button type="button" label="{{'vbeiOk' | translate}}" pButton (click)="closeDialogBox()"></button>
    </div>
  </p-footer>
</p-dialog>